// extracted by mini-css-extract-plugin
export default {"h2":"H2title_h2__rbq62","white":"H2title_white__6XT7G"};